import { useState, useEffect } from "react";
import { Category } from "../types/productTypes";
import api from "../../../../../features/auth/axiosConfig";

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchCategories = async () => {
    setLoading(true);

    try {
      const response = await api.get(`/app/v1/pos/category?is_deleted=False`);
      setCategories(response.data.category_details);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const refetchCategories = () => {
    fetchCategories();
  };

  return { categories, loading, refetchCategories };
};
